import React from "react";

import "./newsEvents.css";

const NewsEvents = () => (
  <div className={"container-fluid"}>
    <div className={"newsEvents row"}>
      <h2>News and Events</h2>
    </div>
  </div>
);

export default NewsEvents;
